// Import necessary Firebase modules
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging'; // 🔔 Added for Notifications

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBQ3jdYK0YlpjuY0JH3AWoo6r-DIcI_l4I",
  authDomain: "dev-safelet.firebaseapp.com",
  databaseURL: "https://dev-safelet-default-rtdb.firebaseio.com",
  projectId: "dev-safelet",
  storageBucket: "dev-safelet.firebasestorage.app",
  messagingSenderId: "589008625602",
  appId: "1:589008625602:web:8486a22ce29e0feadf005b",
  measurementId: "G-ECJRXYLCR5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getDatabase(app);
const auth = getAuth(app);
const messaging = getMessaging(app); // 🔔 Add this line for notifications

// Export all needed services
export { app, db, auth, messaging };
